import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'unit-four-lesson-five-guide',
    templateUrl: './_guide.component.html',
    styleUrls: ['../../_shared/lesson-guides/lesson-guide.component.css']
})
export class UnitFourLessonFiveGuideComponent {

    pageTitle: string = "Lesson Guide | Unit 4, Lesson 5 | T-Folio";
    title: string = "Lesson Guide";
    subtitle: string = "Lesson 5: Job Interview Preparation";

    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
}
